module.exports = __webpack_public_path__ + "static/media/grocery store employee.1dc526e3.png";